const dismissButtons = document.querySelectorAll("button.bux-alert__dismiss");

if (dismissButtons) {
	for (const item of dismissButtons) {
		item.addEventListener("click", dismissAlert);
	}
}

function dismissAlert(event: Event) {
    const target = event.target as HTMLElement;
	const alert = target.closest(`.bux-alert`);
    if (alert) {
        alert.remove();
    }
}
